import React from 'react'

export const Loader = ({ loading }) => (
  <div className={`shade ${loading ? 'display' : ''}`}>
    <div className="spinner" />
  </div>
)
